import { notification } from 'antd'
import { useQuery } from 'react-query'

import { QUERY_KEYS } from '@api'

import { SapGeoApi } from './api'

const onError = () => {
  notification.error({
    message: 'Error al obtener los datos',
  })
}

const useGetSapGeo = (companyShortName: string | undefined = 'AR') => {
  const {
    data: sapGeos,
    isLoading: sapGeoIsLoading,
    refetch: sapGeoRefetch,
  } = useQuery(
    [QUERY_KEYS.SAP_GEO, companyShortName],
    () => SapGeoApi.getSapGeo(companyShortName),
    {
      onError,
      refetchOnWindowFocus: false,
      staleTime: Infinity,
    },
  )

  return { sapGeos, sapGeoIsLoading, sapGeoRefetch }
}

export default useGetSapGeo
